import { action } from 'typesafe-actions'
import {
  RelationshipActionTypes,
  GendersActionTypes,
  PatientActionTypes,
  AppointmentsTypes,
  PhysicianTypes,
  IAppointmentResponse,
  IPatientResponse,
  ServiceAreasTypes,
  Cpt4CodeTypes,
  ConfigurationTypes, ConfigurationLogoTypes,
  ContractGroupsTypes
} from './types'

export const relationshipRequest = () =>
  action(RelationshipActionTypes.FETCH_RELATIONSHIPS_REQUEST)

export const relationshipSuccess = (data: string[]) =>
  action(RelationshipActionTypes.FETCH_RELATIONSHIPS_SUCCESS, { data })

export const relationshipFail = (message: string) =>
  action(RelationshipActionTypes.FETCH_RELATIONSHIPS_FAIL, message)

export const genderRequest = () =>
  action(GendersActionTypes.FETCH_GENDERS_REQUEST)

export const genderSuccess = (data: string[]) =>
  action(GendersActionTypes.FETCH_GENDERS_SUCCESS, { data })

export const genderFail = (message: string) =>
  action(GendersActionTypes.FETCH_GENDERS_FAIL, message)

export const patientsRequest = () =>
  action(PatientActionTypes.FETCH_PATIENTS_REQUEST)

export const patientsSuccess = (data: IPatientResponse) =>
  action(PatientActionTypes.FETCH_PATIENTS_SUCCESS, { data })

export const patientsFail = (message: string) =>
  action(PatientActionTypes.FETCH_PATIENTS_FAIL, message)

export const appointmentsRequest = () =>
  action(AppointmentsTypes.FETCH_APPOINTMENTS_REQUEST)

export const appointmentsSuccess = (data: IAppointmentResponse) =>
  action(AppointmentsTypes.FETCH_APPOINTMENTS_SUCCESS, { data })

export const appointmentsFail = (message: string) =>
  action(AppointmentsTypes.FETCH_APPOINTMENTS_FAIL, { message })

export const physiciansRequest = () =>
  action(PhysicianTypes.FETCH_PHYSICIANS_REQUEST)

export const physiciansSuccess = (data: any) =>
  action(PhysicianTypes.FETCH_PHYSICIANS_SUCCESS, { data })

export const physiciansFail = (message: string) =>
  action(PhysicianTypes.FETCH_PHYSICIANS_FAIL, { message })

export const contractGroupsRequest = () =>
  action(ContractGroupsTypes.FETCH_CONTRACT_GROUPS_REQUEST)

export const contractGroupsSuccess = (data: any) =>
  action(ContractGroupsTypes.FETCH_CONTRACT_GROUPS_SUCCESS, { data })

export const contractGroupsFail = (message: string) =>
  action(ContractGroupsTypes.FETCH_CONTRACT_GROUPS_FAIL, { message })

export const serviceAreasRequest = () =>
  action(ServiceAreasTypes.FETCH_SERVICES_AREAS_REQUEST)

export const serviceAreasSuccess = (data: any) =>
  action(ServiceAreasTypes.FETCH_SERVICES_AREAS_SUCCESS, { data })

export const serviceAreasFail = (message: string) =>
  action(ServiceAreasTypes.FETCH_SERVICES_AREAS_FAIL, { message })

export const getCpt4Request = () =>
  action(Cpt4CodeTypes.FETCH_CPT4_CODES_REQUEST)

export const getCpt4Success = (data: any) =>
  action(Cpt4CodeTypes.FETCH_CPT4_CODES_SUCCESS, data)

export const getCpt4Fail = (message: string) =>
  action(Cpt4CodeTypes.FETCH_CPT4_CODES_FAIL, message)

export const createCpt4Request = () =>
  action(Cpt4CodeTypes.CREATE_CPT4_CODES_REQUEST)

export const createCpt4Success = (data: any) =>
  action(Cpt4CodeTypes.CREATE_CPT4_CODES_SUCCESS, data)

export const createCpt4Fail = (message: string) =>
  action(Cpt4CodeTypes.CREATE_CPT4_CODES_FAIL, message)

export const updateCpt4Request = () =>
  action(Cpt4CodeTypes.UPDATE_CPT4_CODES_REQUEST)

export const updateCpt4Success = (data: any) =>
  action(Cpt4CodeTypes.UPDATE_CPT4_CODES_SUCCESS, data)

export const updateCpt4Fail = (message: string) =>
  action(Cpt4CodeTypes.UPDATE_CPT4_CODES_FAIL, message)

  export const deleteCpt4Request = () =>
  action(Cpt4CodeTypes.DELETE_CPT4_CODES_REQUEST)

export const deleteCpt4Success = (data: any) =>
  action(Cpt4CodeTypes.DELETE_CPT4_CODES_SUCCESS, data)

export const deleteCpt4Fail = (message: string) =>
  action(Cpt4CodeTypes.DELETE_CPT4_CODES_FAIL, message)

export const configurationRequest = () =>
  action(ConfigurationTypes.CONFIGURATION_REQUEST)

export const configurationSuccess = (data: any) =>
  action(ConfigurationTypes.CONFIGURATION_SUCCESS, data)

export const configurationFail = (message: string) =>
  action(ConfigurationTypes.CONFIGURATION_FAIL, message)

export const configurationLogoRequest = () =>
  action(ConfigurationLogoTypes.CONFIGURATION_LOGO_REQUEST)

export const configurationLogoSuccess = (data: any) =>
  action(ConfigurationLogoTypes.CONFIGURATION_LOGO_SUCCESS, data)

export const configurationLogoFail = (message: string) =>
  action(ConfigurationLogoTypes.CONFIGURATION_LOGO_FAIL, message)

export const configurationLogoHeaderRequest = () =>
  action(ConfigurationLogoTypes.CONFIGURATION_LOGO_HEADER_REQUEST)

export const configurationLogoHeaderSuccess = (data: any) =>
  action(ConfigurationLogoTypes.CONFIGURATION_LOGO_HEADER_SUCCESS, data)

export const configurationHeaderLogoFail = (message: string) =>
  action(ConfigurationLogoTypes.CONFIGURATION_LOGO_HEADER_FAIL, message)